var map = {
	"./black/mute_camera2.png": "Lb//",
	"./blue/mute_camera2.png": "hyBp",
	"./white/mute_camera2.png": "E77Z"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1vU9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/mute_camera2\.png$
// module id = 1vU9
// module chunks = 24